import { render, staticRenderFns } from "./FeatureLockedNotify.vue?vue&type=template&id=456e3d68&scoped=true"
import script from "./FeatureLockedNotify.vue?vue&type=script&lang=ts"
export * from "./FeatureLockedNotify.vue?vue&type=script&lang=ts"
import style0 from "./FeatureLockedNotify.vue?vue&type=style&index=0&id=456e3d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e3d68",
  null
  
)

export default component.exports